import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { catchError, map } from 'rxjs/operators';
import { of } from 'rxjs';
import { CompanyIntegrationService } from '../services/company-integration.service';
import { TenantService } from '../services/tenant.service';
import { isEmptyGuid } from '../../shared/utils/guid';

/**
 * Rota antiga `configuracoes/integracoes/:pluginId` (#938), que abria o popup de configuração.
 * Continua aceitando link antigo, mas só redireciona: integração gravada → `:id/detalhe`;
 * não gravada → `nova/:idPlugin`. Se a consulta falhar, cai em `nova/:idPlugin`, onde a tela
 * trata o erro de carga.
 */
export const integracaoLegadaGuard: CanActivateFn = (route) => {
  const router = inject(Router);
  const tenantId = route.pathFromRoot
    .map(r => r.paramMap.get('tenantId'))
    .find((id): id is string => !!id) ?? inject(TenantService).activeTenantId();
  const pluginId = route.paramMap.get('pluginId') ?? '';
  const base = ['/', tenantId, 'configuracoes', 'integracoes'];

  const paraCriacao = () => router.createUrlTree([...base, 'nova', pluginId]);

  return inject(CompanyIntegrationService).getAll().pipe(
    map(lista => {
      const gravada = lista.find(i => i.idPlugin === pluginId && !isEmptyGuid(i.id));
      return gravada ? router.createUrlTree([...base, gravada.id, 'detalhe']) : paraCriacao();
    }),
    catchError(() => of(paraCriacao())),
  );
};
